import PropTypes from 'prop-types';

import { Button } from '@codex/basics';
import { Icon } from '@codex/icons';
import styled from 'styled-components';


const StyledButton = styled(Button)`
  min-width: 200px;
  max-width: none;
  width: 100%;
  background-color: #fff;
  opacity: ${(props) => (props.disabled ? '.2' : '1')};
`;

const StyledIcon = styled(Icon)`
  margin-right: 10px;
`;


export default function GeolocationButton(props) {

  return (
    <StyledButton
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
      disabled={props.disabled}
    >
      <StyledIcon icon={'Target'} />
      {props.label}
    </StyledButton>
  );
}


GeolocationButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

GeolocationButton.defaultProps = {
  onClick: () => {}
};
